import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";

// Plans, subscriptions and assessments all live in startup-backend, so this is
// a second call rather than another block on the investor-backend payload. The
// dashboard sends the SAME from/to to both, and both bound the day on
// Asia/Kolkata, so the two halves of the page describe one range.
export const FetchMonetizationAnalytics = ({ from, to }) => {
    return useQuery(
        ['monetization-analytics', from, to],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/admin/monetization-analytics`,
                params: { ...(from ? { from } : {}), ...(to ? { to } : {}) },
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        select: (data) => data?.data?.data ?? null,
        keepPreviousData: true,
        staleTime: 3 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}
